import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import { initMobilePlatform } from "@/utils/capacitor";
import { installGlobalErrorHandlers } from "@/utils/errorLogger";
import { captureAttributionFromUrl } from "@/utils/attribution";

// Initialize Capacitor (no-op on web)
initMobilePlatform();

// Capture uncaught JS errors + Promise rejections to /api/client-errors
installGlobalErrorHandlers();

// First-touch UTM attribution — captures utm_* params on landing into
// localStorage. AuthContext attaches the payload to the user record on
// sign-up / sign-in via POST /api/users/utm.
captureAttributionFromUrl();

// Register the HiBFF service worker so the PWA install prompt becomes
// available on Chrome/Edge/Android. The SW itself is a pass-through (no
// caching) — it exists only to satisfy installability requirements. Native
// Capacitor builds run on a `capacitor://` / `file://` origin where SW
// registration is unsupported, so we feature-detect and skip there.
if (
  typeof window !== 'undefined' &&
  'serviceWorker' in navigator &&
  /^https?:$/.test(window.location.protocol)
) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Silently ignore — a missing SW must not break the app shell.
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
